
import React from 'react';
import { Container as UIContainer } from '@/components/ui/container';

type ContainerProps = React.HTMLAttributes<HTMLDivElement>;

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div ref={ref} className={`container mx-auto px-4 ${className || ''}`} {...props}>
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

export default Container;
